import { fetchSsmlTagsBySpeaker } from '../api/ssmlTags';

const MUTATIONS_MAP = {
    SET_TAGS: 'SET_TAGS'
};

const state = {
    ssmlTags: {}
};

const mutations = {
    [MUTATIONS_MAP.SET_TAGS](state, tags) {
        state.ssmlTags = Object.freeze(tags);
    }
};

const getters = {
    availableTags(state) {
        return Object.keys(state.ssmlTags);
    }
};

const actions = {
    async fetchSsmlTags({ commit }, speaker) {
        const tags = await fetchSsmlTagsBySpeaker(speaker);

        commit(MUTATIONS_MAP.SET_TAGS, tags);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
